import React, {useEffect, useState} from 'react';
import {Button, setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowDownFromLine,
    faArrowUpToLine,
    faBoxOpenFull,
    faMessageBot,
    faMessageLines,
    faTrashCan
} from "@fortawesome/pro-duotone-svg-icons";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import {Autosave, BalloonEditor, Essentials, GeneralHtmlSupport, HtmlComment, Paragraph} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import '../styles/dashboardConversation.css';
import HTMLPlain from '../utils/HTMLPlain';
import Avatar from "../utils/Avatar";
import JSONCheck from "../utils/JSONCheck";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardConversation({width, item, configuration, locale, user, system, Delete, index, viewConversation, viewWorkspace, thinking, viewCompressed, avatar, voice}) {
    const [folded, setFolded] = useState(index !== 0);
    const [iconHover, setIconHover] = useState(null);

    const ButtonFold = data => {
        if (folded && !data) {
            setFolded(false);
        } else {
            setFolded(true);
        }
    }

    const ButtonUserFold = data => {
        const plainText = HTMLPlain(data);
        let itemLength = 15;

        if (width > 992) {
            itemLength = 45;
        } else if (width < 992 && width > 768) {
            itemLength = 30;
        } else if (width < 768) {
            itemLength = 15;
        }

        return plainText.length > itemLength
            ? plainText.substring(0, itemLength) + '...'
            : plainText;
    }

    const ButtonModel = data => {
        if (configuration.ui.dashboard.model) {
            const item = configuration.mobi.model.find(item => item.value === data);
            return item ? item.short : '';
        } else {
            return locale.dashboardConversation.h;
        }
    }

    const ButtonUser = () => {
        if (user.type === 'mobile') {
            return UserMobile(user.id);
        } else {
            return user.id;
        }
    }

    const ButtonToolDetail = data => {
        let text = '';
        if (data.content && Array.isArray(data.content) && data.content.length !== 0) {
            data.content.map(toolItem => {
                if ((toolItem.type === 'tool_use' || toolItem.type === 'function_call') && toolItem.name) {
                    text = text ? (text + ', ' + toolItem.name) : toolItem.name;
                }

                return toolItem;
            })
        }
        return text;
    }

    const UserMobile = data => {
        let formattedText = '';

        if (data.startsWith('+1')) {
            const number = data.slice(2);

            formattedText = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6, 10)}`;
        } else if (data.startsWith('+52')) {
            const number = data.slice(3);

            formattedText = `(${number.slice(0, 2)}) ${number.slice(2, 6)}-${number.slice(6, 10)}`;
        } else {
            formattedText = data;
        }

        return formattedText;
    }

    const EditorContent = data => {
        let text = null;
        let json = null;

        if (data.content && typeof data.content === 'string') {

            text = data.content;
        } else if (data.content && typeof data.content === 'object' && Array.isArray(data.content) && data.content.some(contentItem => contentItem.type && contentItem.type === 'text' && contentItem.text && typeof contentItem.text === 'string')) {

            data.content.map(contentItem => {
                if (contentItem.type && contentItem.type === 'text' && contentItem.text) {
                    text = text ? (text + contentItem.text) : contentItem.text;
                }
                return contentItem;
            })

        }

        if (data.content && typeof data.content === 'object' && Array.isArray(data.content) && data.content.some(contentItem => contentItem.type && contentItem.type !== 'text')) {

            data.content.map(contentItem => {
                if (contentItem.type && contentItem.type !== 'text') {

                    if (contentItem.output && JSONCheck(contentItem.output)) {
                        contentItem.output = JSONCheck(contentItem.output);
                    }
                    if (contentItem.content && JSONCheck(contentItem.content)) {
                        contentItem.content = JSONCheck(contentItem.content);
                    }
                    if (contentItem.input && JSONCheck(contentItem.input)) {
                        contentItem.input = JSONCheck(contentItem.input);
                    }
                    if (contentItem.arguments && JSONCheck(contentItem.arguments)) {
                        contentItem.arguments = JSONCheck(contentItem.arguments);
                    }

                    let jsonString = JSON.stringify(contentItem, null, 2);

                    jsonString = jsonString.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                    jsonString = jsonString.replace(/^( +)/gm, match => '&nbsp;'.repeat(match.length));
                    jsonString = jsonString.replace(/\n/g, '<br>');
                    jsonString = jsonString.replace(/"([^"]+)":/g, '$1:');

                    json = json ? (json + jsonString) : jsonString;
                }
                return contentItem;
            })

        }

        return (text && json) ? (text + '<br><br>' + json) : (text && !json ? text : ((!text && json) ? json : '' ));
    }

    const ToolUse = data => {
        if (data.role && (data.role === 'function_call' || data.role === 'function_call_output')) {
            return true;
        } else if (data.content && Array.isArray(data.content) && data.content.length !== 0 && data.content.some(contentItem => typeof contentItem === 'object' && contentItem !== null && (contentItem.type === 'tool_use' || contentItem.type === 'tool_result' || contentItem.type === 'function_call' || contentItem.type === 'function_call_output'))) {
            return true;
        } else {
            return false;
        }
    }

    const Header = () => {
        if (folded && item.role === 'assistant') {
            return "mbsc-row cs-dashboard-conversation-header-folded-assistant";
        } else if (folded && item.role !== 'assistant') {
            return "mbsc-row cs-dashboard-conversation-header-folded-user";
        } else if (!folded && item.role === 'assistant') {
            return "mbsc-row cs-dashboard-conversation-header-assistant";
        } else if (!folded && item.role !== 'assistant') {
            return "mbsc-row cs-dashboard-conversation-header-user";
        }
    }

    const Body = () => {
        if (item.role === 'assistant') {
            return "mbsc-row cs-dashboard-conversation-main-assistant";
        } else if (item.role !== 'assistant') {
            return "mbsc-row cs-dashboard-conversation-main-user";
        }
    }

    const MemoryUsage = (totalTokens, contextLimit) => {
        if (
            typeof totalTokens !== "number" ||
            typeof contextLimit !== "number" ||
            contextLimit <= 0 ||
            totalTokens < 0
        ) {
            throw new Error(
                "Invalid input: totalTokens must be >= 0 and contextLimit must be > 0."
            );
        }

        const raw = (totalTokens / contextLimit) * 100;

        return Math.min(parseFloat(raw.toFixed(1)), 100);
    }

    useEffect(() => {
        if (viewWorkspace) {
            setFolded(true);
        } else if (!viewWorkspace && index === 0 && !thinking) {
            setFolded(false);
        } else if (thinking && index === 0) {
            setFolded(true);
        }
    }, [viewWorkspace, index, thinking]);

    return (
        <>
            {((index !== 0 && viewConversation && !viewCompressed && !item.compressed) || (index !== 0 && viewConversation && viewCompressed) || index === 0) &&
                <div className={Header()}>
                    <div className="mbsc-col cs-dashboard-conversation-col-start">
                        {item.role === 'assistant' && !ToolUse(item) &&
                            <Button id={item.id} disabled={item.compressed} onClick={() => ButtonFold(item.compressed)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color" >
                                <div style={{backgroundImage: Avatar({avatar, voice, configuration})}} className="cs-dashboard-conversation-avatar" />{width > 768 && '\u00A0'}
                                {!folded &&
                                    <div className="cs-dashboard-conversation-menu-text">
                                        {width > 576 && ButtonModel(item.model)}
                                        {item.context && item.usage && width > 576 && ButtonModel(item.model) && '\u00A0\u00A0|\u00A0\u00A0'}
                                        {item.context && item.usage && width > 768 && locale.dashboardConversation.d + ': ' + MemoryUsage(item.usage.tokensTotal, item.context) + '%'}
                                        {item.context && item.usage && width < 768 && locale.dashboardConversation.e + ': ' + MemoryUsage(item.usage.tokensTotal, item.context) + '%'}
                                    </div>
                                }
                                {folded && width > 375 &&
                                    <div className="cs-dashboard-conversation-menu-text mbsc-txt-muted">
                                        {ButtonUserFold(EditorContent(item))}
                                    </div>
                                }
                            </Button>
                        }
                        {ToolUse(item) &&
                            <Button disabled={item.compressed} onClick={() => ButtonFold(item.compressed)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color" >
                                <FontAwesomeIcon className="cs-dashboard-conversation-icon" icon={faMessageBot} />{width > 768 && '\u00A0'}
                                {width > 375 &&
                                    <div className={folded ? "cs-dashboard-conversation-menu-text mbsc-txt-muted" : "cs-dashboard-conversation-menu-text"}>
                                        {!ButtonToolDetail(item) && locale.dashboardConversation.c}{ButtonToolDetail(item) && (locale.dashboardConversation.b + ': ')}{ButtonToolDetail(item) && ButtonToolDetail(item)}
                                    </div>
                                }
                            </Button>
                        }
                        {item.role === 'user' && !ToolUse(item) &&
                            <Button disabled={item.compressed} onClick={() => ButtonFold(item.compressed)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color" >
                                {user.avatar ? <div style={{backgroundImage: "url(https://www.gravatar.com/avatar/" + user.avatar + "?d=robohash)"}} className={width > 768 ? "cs-dashboard-conversation-avatar" : "cs-dashboard-conversation-avatar-xs"} /> : <FontAwesomeIcon className="cs-dashboard-conversation-icon" icon={faMessageLines} />}{width > 768 && '\u00A0'}
                                {!folded &&
                                    <div className="cs-dashboard-conversation-menu-text">
                                        {ButtonUser()}
                                    </div>
                                }
                                {folded && width > 375 &&
                                    <div className="cs-dashboard-conversation-menu-text mbsc-txt-muted">
                                        {ButtonUserFold(EditorContent(item))}
                                    </div>
                                }
                            </Button>
                        }
                    </div>
                    <div className="mbsc-col-auto">
                        <div className="mbsc-row">
                            {system && item.role !== 'system' &&
                                <Button onMouseEnter={() => setIconHover('trash-' + item.id)} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color"  onClick={() => Delete(item.id)} >
                                    {'\u00A0'}<FontAwesomeIcon className="cs-dashboard-conversation-icon" icon={faTrashCan} fade={iconHover === ('trash-' + item.id)} />
                                </Button>
                            }
                            {!item.compressed &&
                                <Button onMouseEnter={() => setIconHover('arrow-' + item.id)} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color" onClick={() => ButtonFold(item.compressed)} >
                                    {!system && '\u00A0'}<FontAwesomeIcon className="cs-dashboard-conversation-icon" icon={folded ? faArrowDownFromLine : faArrowUpToLine} fade={iconHover === ('arrow-' + item.id)} />
                                </Button>
                            }
                            {item.compressed &&
                                <Button onMouseEnter={() => setIconHover('compress-' + item.id)} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-conversation-color" >
                                    {width > 576 && !system && <div className="cs-dashboard-conversation-menu-text-right mbsc-txt-muted">{width > 768 ? locale.dashboardConversation.k : locale.dashboardConversation.g}</div>}<FontAwesomeIcon className="cs-dashboard-conversation-icon" icon={faBoxOpenFull} fade={iconHover === ('compress-' + item.id)} />
                                </Button>
                            }
                        </div>
                    </div>
                </div>
            }
            {!folded &&
                <div className={Body()} >
                    <div className="mbsc-col cs-dashboard-conversation-editor">
                        <CKEditor
                            onReady={editor => {
                                editor.enableReadOnlyMode('editor-dashboard-conversation');
                            }}
                            editor={BalloonEditor}
                            data={EditorContent(item)}
                            disableWatchdog={true}
                            config={{
                                toolbar: {
                                    items: [],
                                    shouldNotGroupWhenFull: true
                                },
                                plugins: [
                                    Autosave,
                                    Essentials,
                                    GeneralHtmlSupport,
                                    HtmlComment,
                                    Paragraph
                                ],
                                htmlSupport: {
                                    allow: [
                                        {
                                            name: /^.*$/,
                                            styles: true,
                                            attributes: true,
                                            classes: true
                                        }
                                    ]
                                },
                                licenseKey: 'GPL',
                                ui: {
                                    poweredBy: {position:'inside', side:'right'}
                                }
                            }}
                        />
                    </div>
                </div>
            }
        </>
    );
}

export default DashboardConversation;
